import React from 'react';
import {
    List, Datagrid, TextField, DateField,
    ReferenceField, ImageField, EmailField,Filter, TextInput, ReferenceInput, AutocompleteInput,
    NumberField, BooleanField, EditButton
} from 'react-admin';
import queryString from 'query-string';
import {useLocation} from "react-router-dom";
const UserFilter = props => (
    <Filter  {...props}>
        <TextInput label="Name" source="userName~like" variant="outlined"  />        
        <TextInput label="Email" source="email~like"  variant="outlined" />
        <TextInput label="Mobile" source="mobile~like" variant="outlined"  />
    </Filter>
);
export const UserList = props => {
    let location = useLocation();

    const values = queryString.parse(location.search);
    const usertype =0;// (values.typeid) ? values.typeid : 0;
    let propsObj = { ...props };
    if (propsObj.permissions) {
      let resourcename = `/${props.resource}`;
      let myPermissions = propsObj.permissions.filter(item => item.NavigateUrl.toLowerCase().trim() == resourcename);
      if (myPermissions.length > 0) {
        let p = myPermissions[0];
        propsObj.hasList = (p.View == 1) ? true : false;
        propsObj.hasShow = (p.View == 1) ? true : false;
        propsObj.hasEdit = (p.Edit == 1) ? true : false;
        propsObj.hasDelete = (p.Delete == 1) ? true : false;
        propsObj.hasCreate = (p.Create == 1) ? true : false;
        propsObj.hasExport = (p.Export == 1) ? true : false;
      }
    }
     

    return (
        <List title={`Freelancer List`} {...propsObj} exporter={propsObj.hasExport}  bulkActionButtons={false}filters={<UserFilter />} filter = {{ typeId: 2 }} >
        <Datagrid rowClick={propsObj.hasEdit ? 'edit' :  false}>
        <TextField source="userName" />
            <TextField source="email" />
            <TextField source="initials" />
            <TextField source="firstName" />
            <TextField source="lastName" />
            <EmailField source="email" />
            <TextField source="mobile" />
            <ReferenceField label="User Role" source="roleId" reference="role-types" link={false}>
                <TextField source="roleName" />
            </ReferenceField>
            <BooleanField source="status" label="Is Active" />
        </Datagrid>
    </List>
)};